import React from 'react';

// ==================== UK PAGE ====================
const UKPage = ({ onBack }) => {
    return (
        <div className="uk-page">
            {/* Hero Section */}
            <section className="hero-section relative overflow-hidden min-h-screen flex items-center justify-center">
                <div className="absolute inset-0 z-0">
                    <div
                        className="absolute inset-0 full-bg-section"
                        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?auto=format&fit=crop&w=3840&q=95')" }}
                    />
                </div>
                <div className="hero-overlay absolute inset-0 z-10"></div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 md:pt-36 pb-16 w-full relative z-20">
                    <div className="text-white text-center">
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6">
                            Study in the UK – Fast-Track Your Global Career
                        </h1>
                        <p className="text-xl md:text-2xl mb-4 text-primary-red font-semibold">
                            Top Universities | Short Duration Courses | High Visa Success
                        </p>
                        <p className="text-lg md:text-xl mb-8 text-gray-100 leading-relaxed max-w-3xl mx-auto">
                            Achieve your dream of studying in the United Kingdom with expert guidance from Swan Global. We provide complete support from admission to visa approval.
                        </p>
                        <div className="hero-buttons flex flex-wrap gap-4 justify-center">
                            <a
                                href="mailto:info@swanglobaledu.com?subject=Book%20Free%20Consultation%20for%20UK"
                                className="btn-primary inline-flex items-center gap-2"
                            >
                                <i className="fas fa-calendar-check"></i>
                                Book FREE Consultation
                            </a>
                            <a
                                href="https://wa.me/919000329999"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-secondary inline-flex items-center gap-2"
                            >
                                <i className="fab fa-whatsapp"></i>
                                WhatsApp Now (+91-9000329999)
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Study in the UK */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">Why Choose the UK?</h2>
                        <p className="text-xl text-primary-red font-semibold">
                            The UK is one of the top destinations for Indian students seeking quality education in a shorter time.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
                        {[
                            { icon: 'fa-graduation-cap', title: 'Globally recognized universities' },
                            { icon: 'fa-clock', title: 'Shorter course duration (1-year Masters)' },
                            { icon: 'fa-briefcase', title: 'Post-study work opportunities (PSW visa)' },
                            { icon: 'fa-globe', title: 'Multicultural environment' },
                            { icon: 'fa-award', title: 'High academic standards' },
                        ].map((item, index) => (
                            <div key={index} className="bg-lightGray p-6 rounded-2xl text-center">
                                <div className="w-16 h-16 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-4">
                                    <i className={`fas ${item.icon} text-white text-2xl`}></i>
                                </div>
                                <p className="text-black font-medium">{item.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Why Swan Global for UK */}
            <section className="py-20 bg-lightGray">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid lg:grid-cols-2 gap-16 items-center">
                        <div>
                            <img
                                src="https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?w=600&q=80"
                                alt="UK Education"
                                className="rounded-2xl shadow-xl"
                            />
                        </div>
                        <div>
                            <h2 className="text-4xl font-bold text-black mb-6">
                                Trusted <span className="text-primary-red">UK</span> Education Consultants in Hyderabad
                            </h2>
                            <p className="text-lg text-gray mb-6 leading-relaxed">
                                Swan Global has successfully guided students to leading UK universities with a smooth admission and visa process.
                            </p>
                            <ul className="space-y-4">
                                {[
                                    'High visa success rate',
                                    'Expert university & course selection',
                                    'Complete visa assistance',
                                    'Personalized counseling',
                                    'End-to-end support',
                                ].map((feature, index) => (
                                    <li key={index} className="flex items-center gap-4">
                                        <div className="w-10 h-10 bg-primary-red rounded-full flex items-center justify-center text-white flex-shrink-0">
                                            <i className="fas fa-check"></i>
                                        </div>
                                        <span className="text-lg text-black font-medium">{feature}</span>
                                    </li>
                                ))}
                            </ul>
                            <p className="text-xl text-primary-red font-semibold mt-8">
                                Your reliable partner for studying in the UK
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Services */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">Complete Support for Your UK Journey</h2>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {[
                            { icon: 'fa-user-graduate', title: 'Career Counseling' },
                            { icon: 'fa-university', title: 'University & Course Selection' },
                            { icon: 'fa-file-alt', title: 'SOP & Documentation Support' },
                            { icon: 'fa-money-check-alt', title: 'Education Loan Assistance' },
                            { icon: 'fa-passport', title: 'Visa Filing & Interview Preparation' },
                            { icon: 'fa-plane-departure', title: 'Pre-Departure Guidance' },
                        ].map((service, index) => (
                            <div key={index} className="bg-lightGray p-8 rounded-2xl text-center">
                                <div className="w-16 h-16 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-4">
                                    <i className={`fas ${service.icon} text-white text-2xl`}></i>
                                </div>
                                <h3 className="text-xl font-semibold text-black">{service.title}</h3>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Process */}
            <section className="py-20 bg-lightGray">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">Simple Steps to Study in the UK</h2>
                    </div>

                    <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
                        {[
                            { step: '1', title: 'Free Consultation' },
                            { step: '2', title: 'Profile Evaluation' },
                            { step: '3', title: 'Course & University Selection' },
                            { step: '4', title: 'Application Submission' },
                            { step: '5', title: 'SOP & Documentation' },
                            { step: '6', title: 'Visa Filing' },
                            { step: '7', title: 'Fly to the UK ✈️' },
                        ].map((item, index) => (
                            <div key={index} className="bg-white p-6 rounded-2xl text-center">
                                <div className="w-12 h-12 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-xl">
                                    {item.step}
                                </div>
                                <p className="text-black font-medium">{item.title}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Success Section */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">Our UK Success</h2>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8 text-center">
                        <div className="bg-lightGray p-8 rounded-2xl">
                            <span className="text-5xl font-extrabold text-primary-red block mb-2">50+</span>
                            <span className="text-lg text-black">Students Placed in Top UK Universities</span>
                        </div>
                        <div className="bg-lightGray p-8 rounded-2xl">
                            <span className="text-5xl font-extrabold text-primary-red block mb-2">95%</span>
                            <span className="text-lg text-black">Visa Success Rate</span>
                        </div>
                        <div className="bg-lightGray p-8 rounded-2xl">
                            <span className="text-5xl font-extrabold text-primary-red block mb-2">100%</span>
                            <span className="text-lg text-black">Trusted by Hyderabad Students</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            <section id="testimonials" className="py-20 bg-lightGray" style={{ minHeight: '50vh' }}>
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-12">
                        <h2 className="text-4xl font-bold text-black mb-4">What Students Say</h2>
                    </div>

                    <div className="grid md:grid-cols-2 gap-8">
                        {[
                            {
                                text: 'Swan Global guided me perfectly for my UK admission and visa. Highly professional team.',
                                name: 'Priya Patel',
                                country: 'UK',
                            },
                            {
                                text: 'Very smooth process. Got my UK visa without stress.',
                                name: 'Rahul Sharma',
                                country: 'UK',
                            },
                        ].map((testimonial, index) => (
                            <div key={index} className="bg-white p-8 rounded-2xl shadow-lg">
                                <div className="flex text-yellow-400 mb-4">
                                    {[...Array(5)].map((_, i) => (
                                        <i key={i} className="fas fa-star"></i>
                                    ))}
                                </div>
                                <p className="text-gray italic mb-6">"{testimonial.text}"</p>
                                <div className="flex items-center gap-4">
                                    <div className="w-12 h-12 bg-primary-red rounded-full flex items-center justify-center text-white">
                                        <i className="fas fa-user"></i>
                                    </div>
                                    <div>
                                        <h4 className="text-lg font-semibold text-black">{testimonial.name}</h4>
                                        <span className="text-primary-red text-sm">{testimonial.country}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-20 bg-primary-red relative overflow-hidden">
                <div className="absolute top-0 right-0 w-96 h-96 bg-white opacity-10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                <div className="absolute bottom-0 left-0 w-72 h-72 bg-white opacity-5 rounded-full translate-y-1/2 -translate-x-1/2"></div>

                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
                    <h2 className="text-4xl font-bold text-white mb-4">
                        Ready to Study in the UK?
                    </h2>
                    <p className="text-xl text-white/90 mb-10">
                        Get expert guidance from Hyderabad's trusted UK consultants.
                    </p>
                    <p className="text-lg text-white/80 mb-8">
                        Limited FREE consultation slots available!
                    </p>
                    <div className="flex flex-wrap justify-center gap-4">
                        <a
                            href="mailto:info@swanglobaledu.com?subject=Book%20Free%20Consultation%20for%20UK"
                            className="bg-white text-primary-red px-8 py-4 rounded-full font-semibold hover:bg-black hover:text-white transition-all duration-300 inline-flex items-center gap-2"
                        >
                            <i className="fas fa-calendar-check"></i>
                            Book Free Consultation
                        </a>
                        <a
                            href="https://wa.me/919000329999"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-transparent text-white border-2 border-white px-8 py-4 rounded-full font-semibold hover:bg-white hover:text-primary-red transition-all duration-300 inline-flex items-center gap-2"
                        >
                            <i className="fab fa-whatsapp"></i>
                            WhatsApp Now
                        </a>
                    </div>
                </div>
            </section>

            {/* Contact Line */}
            <section className="py-12 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <p className="text-lg text-gray">
                        📍 613, 6th floor, Fairmount Downtown, Kompally, Secunderabad, Hyderabad, Telangana- 500100
                    </p>
                </div>
            </section>

            {/* Back Button */}
            <div className="fixed bottom-4 left-4 md:bottom-6 md:left-6 z-50">
                <button
                    onClick={onBack}
                    className="bg-primary-red text-white px-4 md:px-6 py-2.5 md:py-3 rounded-full text-sm md:text-base font-semibold hover:bg-primary-dark transition-all duration-300 shadow-lg flex items-center gap-2"
                >
                    <i className="fas fa-arrow-left"></i>
                    Back to Home
                </button>
            </div>
        </div>
    );
};

export default UKPage;

